import React from "react";
import styled from "styled-components";
import { Spacing, content } from "@glossy";

const Footer = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: ${Spacing.Large};
  gap: ${Spacing.ExtraSmall};
  border-top: 1px solid ${(props) => content(props, "tertiary")};
`;

const UiKitFormFooter = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => <Footer className={className}>{children}</Footer>;

export default UiKitFormFooter;
